<template>
  <v-layout>
    <v-flex v-for="i in field.count" :key="i">
      <v-text-field
        :label="label"
        v-model="localData[i-1]"></v-text-field>
    </v-flex>
  </v-layout>
</template>

<script>
import Field from '@/mixins/JsonEditorField'

export default {
  name: 'JsonMultiple',
  mixins: [Field],
  created () {
    this.localData = []
  },
  mounted () {
    while (this.localData.length < this.field.count) {
      this.localData.push('')
    }
  }
}
</script>
